import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import BASE_URL from "../../BASEURL";

export default function Coupons() {
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCoupons();
  }, []);

  const fetchCoupons = async () => {
    try {
      const res = await fetch(`${BASE_URL}/api/coupon`);
      const data = await res.json();
      setCoupons(data.coupons || []);
    } catch (error) {
      console.error("Error fetching coupons:", error);
    } finally {
      setLoading(false);
    }
  };

  const deleteCoupon = async (id) => {
    if (window.confirm("Are you sure you want to delete this coupon?")) {
      try {
        await fetch(`${BASE_URL}/api/coupon/${id}`, { method: "DELETE" });
        fetchCoupons();
      } catch (error) {
        console.error("Error deleting coupon:", error);
      }
    }
  };

  if (loading) return <div>Loading coupons...</div>;

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Coupons</h2>
      <div className="bg-white border rounded overflow-x-auto">
        <table className="w-full text-sm text-left border-collapse">
          <thead className="bg-gray-100 border-b">
            <tr>
              <th className="p-2 border-r">Code</th>
              <th className="p-2 border-r">Discount %</th>
              <th className="p-2 border-r">Valid Until</th>
              <th className="p-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            {coupons.map((c) => (
              <tr key={c._id} className="border-b hover:bg-gray-50">
                <td className="p-2 border-r font-bold">{c.code}</td>
                <td className="p-2 border-r">{c.discountPercentage}%</td>
                <td className="p-2 border-r">{new Date(c.validUntil).toLocaleDateString()}</td>
                <td className="p-2">
                  <Link to={`/admin/coupons/edit/${c._id}`} className="text-blue-600 hover:underline mr-3">
                    Edit
                  </Link>
                  <button onClick={() => deleteCoupon(c._id)} className="text-red-600 hover:underline">
                    Delete
                  </button>
                </td>
              </tr>
            ))}
            {coupons.length === 0 && (
              <tr><td colSpan="4" className="p-4 text-center">No coupons found.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
